var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { height: "100%", position: "relative" } }, [
    _c(
      "div",
      {
        staticClass:
          "is-flex is-justify-content-space-between is-align-items-center booking-header",
      },
      [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.selectedBooking && _vm.innerIsShowDetail
                ? `Vehicle No: ` + _vm.selectedBooking.vehicleRegistrationNo
                : "Bookings"
            )
          ),
        ]),
        !_vm.innerIsShowDetail
          ? _c("span", [_vm._v(_vm._s(_vm.totalBookings || 0))])
          : _vm._e(),
        _c(
          "div",
          {
            staticStyle: { position: "absolute", top: "-3px", left: "-46px" },
            on: {
              click: function ($event) {
                return _vm.$emit("handleSidePanelToggle")
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "side-panel-slide-button is-flex is-align-items-center is-justify-content-center",
              },
              [
                _c("span", {
                  staticClass: "mdi mdi-30px",
                  class: {
                    "mdi-chevron-left": !_vm.isSidePanelOpen,
                    "mdi-chevron-right": _vm.isSidePanelOpen,
                    "mdi-close": _vm.innerIsShowDetail,
                  },
                }),
              ]
            ),
          ]
        ),
      ]
    ),
    !_vm.innerIsShowDetail
      ? _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTextField,
                  expression: "searchTextField",
                },
              ],
              staticClass: "input is-capitalized",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.searchTextField },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onSearch()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchTextField = $event.target.value
                },
              },
            }),
            !!_vm.searchTextField
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-right is-clickable",
                    on: { click: _vm.clearSearch },
                  },
                  [_c("i", { staticClass: "mdi mdi-close has-text-white" })]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    !_vm.innerIsShowDetail
      ? _c(
          "div",
          { staticClass: "quote-card-section", attrs: { id: "myDraggable" } },
          _vm._l(_vm.filteredBookings, function (booking) {
            return _c(
              "div",
              {
                key: booking.quoteBookingId,
                staticClass: "quote-card mb-3 draggable-item",
                class: `calendar-quote-card-background-${_vm.$theme.name}`,
                attrs: {
                  "data-event": JSON.stringify({
                    uniqueId: booking.quoteBookingId,
                    title: booking.vehicleRegistrationNo,
                  }),
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-justify-content-space-between quote-card-header",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "is-flex is-align-items-center" },
                      [
                        _c(
                          "span",
                          { staticClass: "msr msr-20px has-text-warning mr-1" },
                          [_vm._v("schedule")]
                        ),
                        _c("span", { staticClass: "is-size-6" }, [
                          _vm._v(_vm._s(booking.vehicleRegistrationNo)),
                        ]),
                      ]
                    ),
                    _c("div", [
                      _c("span", { staticClass: "is-size-7" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatDateTimeLocale(
                                `${booking.createdDate}`,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "quote-body" }, [
                  _vm.bookings.bookingType || _vm.bookings.brand
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-justify-content-space-between my-1",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getNameById(
                                  _vm.storeBookingTypes,
                                  booking.bookingType
                                )
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getNameById(
                                  _vm.storeIntegrationTypes,
                                  booking.integrationType
                                )
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-justify-content-space-between vehicle-info",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "is-flex is-flex-direction-row" },
                        [
                          _c("div", [_vm._v(_vm._s(booking.vehicleMake))]),
                          _c("div", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(booking.vehicleModel)),
                          ]),
                        ]
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              booking.excess,
                              _vm.$userInfo.locale,
                              false,
                              2
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm.selectedBooking && _vm.innerIsShowDetail
      ? _c("div", [
          _vm.isQuote
            ? _c("div", { staticClass: "field" }, [
                _vm.isQuote && _vm.selectedBookingQuote.quoteIsRepairBooked
                  ? _c("span", { staticClass: "is-rounded is-success tag" }, [
                      _vm._v("Booked"),
                    ])
                  : _vm._e(),
                _vm.isQuote && _vm.selectedBookingQuote.quoteIsAuthorised
                  ? _c(
                      "span",
                      { staticClass: "is-rounded is-success tag ml-2" },
                      [_vm._v("Authorised")]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.isQuote
            ? _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "columns" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "column" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.selectedBookingQuote.totalExGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(1),
              _c("div", { staticClass: "column" }, [
                _c("p", [_vm._v(_vm._s(_vm.selectedBooking.claimNo))]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(2),
              _c(
                "div",
                {
                  staticClass: "column",
                  class: {
                    "has-text-grey-light": !_vm.selectedBooking.quoteNo,
                  },
                },
                [
                  _vm.selectedBooking.quoteNo
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleQuoteClick(
                                _vm.selectedBooking.quoteId
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.selectedBooking.quoteNo))]
                      )
                    : _c("p", [_vm._v("Not Quoted")]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "field pb-2" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(3),
              _c("div", { staticClass: "column" }, [
                _vm._v(" " + _vm._s(_vm.vehicleDetails) + " "),
              ]),
            ]),
          ]),
          _vm.isQuote
            ? _c("span", [
                _c("div", { staticClass: "field pb-2" }, [
                  _c("div", { staticClass: "columns" }, [
                    _vm._m(4),
                    _c("div", { staticClass: "column" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedBooking.quoteCustomerName) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field pb-2" }, [
                  _c("div", { staticClass: "columns" }, [
                    _vm._m(5),
                    _c("div", { staticClass: "column" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedBooking.quoteCustomerMobile) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _vm.selectedBookingQuote.quoteIsRepairBooked != null &&
                _vm.selectedBookingQuote.quoteIsRepairBooked
                  ? _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Vehicle Arrival Date"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "is-fullwidth" },
                        [
                          _c("v-date-picker", {
                            ref: "datepicker",
                            staticClass: "is-fullwidth",
                            attrs: {
                              "is-dark": _vm.$theme.isDark,
                              mode: "dateTime",
                              "minute-increment": 5,
                              masks: _vm.formats,
                              attributes: _vm.attrs,
                              locale: _vm.$userInfo.locale,
                              "model-config": _vm.innerArrivedForRepairDate
                                ? {}
                                : _vm.modelConfig,
                              timezone: _vm.$filters.getIanaTimezone(),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ inputValue, inputEvents }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field has-addons" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control is-expanded has-icons-left",
                                            },
                                            [
                                              _c(
                                                "input",
                                                _vm._g(
                                                  {
                                                    staticClass: "input",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Arrive for Repair Date",
                                                      readonly: "",
                                                    },
                                                    domProps: {
                                                      value: inputValue,
                                                    },
                                                  },
                                                  inputEvents
                                                )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "icon is-small is-left",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-calendar mdi-18px",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2592718411
                            ),
                            model: {
                              value: _vm.innerArrivedForRepairDate,
                              callback: function ($$v) {
                                _vm.innerArrivedForRepairDate = $$v
                              },
                              expression: "innerArrivedForRepairDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Estimated Start Date"),
                    ]),
                    _vm.isRepairStartDateSynced
                      ? _c("input", {
                          staticClass: "input is-static",
                          attrs: { readonly: "" },
                          domProps: {
                            value: _vm.$filters.formatDateTimeLocale(
                              _vm.selectedBookingQuote.jobStart,
                              _vm.$userInfo.locale
                            ),
                          },
                        })
                      : _c("v-date-picker", {
                          ref: "datepicker",
                          attrs: {
                            "is-dark": _vm.$theme.isDark,
                            mode: "dateTime",
                            "minute-increment": 5,
                            masks: _vm.formats,
                            attributes: _vm.attrs,
                            locale: _vm.$userInfo.locale,
                            "model-config": _vm.innerJobStartDate
                              ? {}
                              : _vm.modelConfig,
                            "max-date": _vm.innerJobEndDate,
                            timezone: _vm.$filters.getIanaTimezone(),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ inputValue, inputEvents }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "field is-fullwidth" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "control has-icons-left",
                                          },
                                          [
                                            _c(
                                              "input",
                                              _vm._g(
                                                {
                                                  staticClass: "input",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "Job Start Date",
                                                    content:
                                                      _vm.ormJobEndJobEndValidationText,
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: inputValue,
                                                  },
                                                },
                                                inputEvents
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon is-small is-left",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-calendar mdi-18px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2025666046
                          ),
                          model: {
                            value: _vm.innerJobStartDate,
                            callback: function ($$v) {
                              _vm.innerJobStartDate = $$v
                            },
                            expression: "innerJobStartDate",
                          },
                        }),
                    _vm.isRepx
                      ? _c("span", { staticClass: "help is-info" }, [
                          _vm._v(
                            "Once the Start Date is synced, it cannot be updated."
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Estimated End Date"),
                    ]),
                    _c("v-date-picker", {
                      ref: "datepicker",
                      staticClass: "is-fullwidth",
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        mode: "dateTime",
                        "minute-increment": 5,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        "model-config": _vm.innerJobEndDate
                          ? {}
                          : _vm.modelConfig,
                        "min-date": _vm.innerJobStartDate,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      on: { input: _vm.jobEndDateInputEvent },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field has-addons" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "control is-expanded has-icons-left",
                                    },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Job End Date",
                                              content:
                                                _vm.ormJobEndJobEndValidationText,
                                              readonly: "",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3023751271
                      ),
                      model: {
                        value: _vm.innerJobEndDate,
                        callback: function ($$v) {
                          _vm.innerJobEndDate = $$v
                        },
                        expression: "innerJobEndDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm.selectedBookingQuote.quoteIsRepairBooked != null &&
                _vm.selectedBookingQuote.quoteIsRepairBooked
                  ? _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Vehicle Onsite"),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("div", { staticClass: "pretty p-switch p-fill" }, [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: !!_vm.innerIsArrived },
                            on: { change: _vm.isArrivedOnChange },
                          }),
                          _c("div", { staticClass: "state p-primary" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.innerIsArrived ? "Yes" : "No")),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _c("span", [
                _c("div", { staticClass: "field mt-5" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Inspection Booking Date"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "is-fullwidth" },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          "model-config": _vm.modelConfig,
                          locale: _vm.$userInfo.locale,
                          timezone: _vm.$filters.getIanaTimezone(),
                          "min-date": _vm.minDate,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ inputValue, inputEvents }) {
                                return [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "div",
                                      { staticClass: "control has-icons-left" },
                                      [
                                        _c(
                                          "input",
                                          _vm._g(
                                            {
                                              staticClass: "input",
                                              class: {
                                                "is-invalid":
                                                  _vm.$v
                                                    .innerBookingStartDateTime
                                                    .$dirty &&
                                                  !_vm.$v
                                                    .innerBookingStartDateTime
                                                    .required,
                                              },
                                              attrs: {
                                                type: "text",
                                                placeholder: "Date",
                                                disabled: _vm.isQuote,
                                              },
                                              domProps: { value: inputValue },
                                            },
                                            inputEvents
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "icon is-small is-left",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-calendar mdi-18px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          915441192
                        ),
                        model: {
                          value: _vm.innerBookingStartDateTime,
                          callback: function ($$v) {
                            _vm.innerBookingStartDateTime = $$v
                          },
                          expression: "innerBookingStartDateTime",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Inspection Booking Time"),
                  ]),
                  _c("div", { staticClass: "control is-extended" }, [
                    _c(
                      "div",
                      {
                        staticClass: "select is-fullwidth",
                        class: {
                          "is-invalid":
                            _vm.$v.innerBookingStartTime.$dirty &&
                            !_vm.$v.innerBookingStartTime.required,
                        },
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerBookingStartTime,
                                expression: "innerBookingStartTime",
                              },
                            ],
                            ref: "insepctionBookingTime",
                            attrs: { disabled: _vm.isQuote },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.innerBookingStartTime = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(
                              _vm.inspectionBookingTimeSlots,
                              function (s, index) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: _vm.extractTimeOnly(s) },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.extractTimeOnly(s)) + " "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
          _c(
            "div",
            {
              staticClass:
                "field is-grouped is-justify-content-space-between mt-5",
            },
            [
              _c("div", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    attrs: { "data-tooltip": "View Booking" },
                    on: {
                      click: function ($event) {
                        _vm.isQuote
                          ? _vm.handleQuoteClick(_vm.selectedBooking.quoteId)
                          : _vm.handleBookingRedirect()
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.isQuote ? "View Quote" : "View Booking")
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-success tooltip",
                    attrs: { "data-tooltip": "Save changes" },
                    on: {
                      click: function ($event) {
                        _vm.isQuote ? _vm.handleQuoteSave() : _vm.save()
                      },
                    },
                  },
                  [_vm._m(6), _c("span", [_vm._v("Save")])]
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-two-fifths" }, [
      _c("label", { staticClass: "label" }, [
        _vm._v("Total "),
        _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
        _vm._v(":"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-two-fifths" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Claim No:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-two-fifths" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Quote No:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-two-fifths" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Vehicle Details:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-two-fifths" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Customer Details:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-two-fifths" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Customer Mobile:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-content-save mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }